/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Vehicle Inspection Icon component.
 *
 * ! NOTE: This Icon defines non-standard sizes within the DLS
 *   https://www.figma.com/file/gtF4hB3eC4fvzKVJ2DNDtu/00_DLS_Foundation?node-id=1%3A172
 */
export const SideNavInspectionsIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='SideNavInspectionsIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 19 25' fill='none'>
        <g>
          <rect x={0.8}
            y={4.8}
            stroke={iconColor}
            strokeWidth={1.5}
            width={17.5}
            height={19.5}
            rx={1.2}
            ry={1.2} />
          <path d='m12.2 16-1-1-.4.4 1.4 1.4 3-3-.4-.4-2.6 2.6ZM12.2 11l-1-1-.4.4 1.4 1.4 3-3-.4-.4-2.6 2.6Z'
            stroke={iconColor}
            strokeWidth={1.5} />
          <path d='M4 10h4.5v1.5H4zM4 14h4.5v1.5H4zM4 18h4.5v1.5H4zM6 1c0-.4-.3-.8-.8-.8s-.8.3-.8.8h1.5Zm0 4V1H4.5v4H6ZM15 1c0-.4-.3-.8-.8-.8s-.8.3-.8.8h1.5Zm0 4V1h-1.5v4H15Z'
            stroke={iconColor}
            strokeWidth={1.5} />
        </g>
      </svg>
    )} />
  );
};
